<template>
  <div class="ask-show-answer">
    <div class="q-show" v-if="info">
      <h1 class="conpdd" v-if="info.question">
        <img class="answtag" v-lazy="img.questionicon">
        <span class="titleqa">{{ info.question }}</span>
      </h1>
      <p class="conpdd">{{ info.content }}</p>
      <img class="img" v-for="(img, index) in info.image" :key="'img_' + index" v-lazy="img" @click="showImg(index)" />
      <div class="other conpdd" v-if="info.answer_num">
        <router-link :to="{name: 'LexusAskShow', params: {id: info.id}}">
          <span class="f-12 c-getother">查看其它{{ info.answer_num }}个回答&gt;</span>
        </router-link>
      </div>
      <div class="tag conpdd">
        <van-row type="flex" justify="space-between">
          <van-col span="18">
            <span class="f-12 c-gray mr-10" v-for="t in info.labels" :key="'label_' + t.id + '_id_' + info.id">{{ t.name }}</span>
          </van-col>
          <van-col span="6" class="tip" @click="goPost(5)">
            <span class="c-blue f-14">我要回答</span>
          </van-col>
        </van-row>
      </div>
    </div>
    <div class="a-show" v-if="info && info.answer">
      <van-row class="conpdd" type="flex" justify="space-between" v-if="info.answer.user">
       <!-- @click="goMy(info.answer.user.id)" -->
       <van-col span="4">
        <img class="listhand" :src="info.answer.user.headimg_url&&info.answer.user.headimg_url.substring(0,5)=='https' ? info.answer.user.headimg_url : img.avatar">
      </van-col>
      <!-- @click="goMy(info.answer.user.id)" -->
      <van-col span="15">
        <div class="membername">
          {{info.answer.user.user_name}}
        </div>
        <div class="sourtime">
          {{info.answer.answer_time}}
        </div>
      </van-col>
      <van-col class="bintright" span="5">
        <van-button class="follow" v-if="info.answer.user.is_follow==0" @click="follow()" :data-code="info.answer.user.id" icon="plus" color="#5F5B6B" size="small">关 注</van-button>
      </van-col>
    </van-row>
    <div class="f-15" v-for="(item, index) in info.answer.content" :key="'a_c_' + index">
      <div class="conpdd">
        <img class="answtag" :src="img.answericon">
        <span>{{ item.text }}</span>
      </div>
      <img v-if="item.img" v-lazy="item.img" class="img" @click="showImgd(item.img)" />
    </div>

    <div class="parise">
      <router-link to="" @click.native="setAdopt">
        <img :src="info.answer.is_adopt ? img.parise_have : img.show_parise" />
        采纳答案
      </router-link><router-link to="" @click.native="setNoPraise">
        <img :src="info.answer.is_praiseno ? img.no_parise_have : img.show_no_parise" />
        没帮助
      </router-link><router-link to="">
        <img :src="img.answer_black" />
        追加问题
      </router-link>
    </div>
    <van-row class="conpdd" type="flex" justify="space-between">
      <van-col span="14">
        <span class="sourtime" v-if="info.read_num">阅读量{{ info.read_num }}</span>
      </van-col>
      <van-col class="bintright" span="10">
        <span class="sourtime" @click="toTip">举报</span>
      </van-col>
    </van-row>
  </div>
  <!-- 评论 -->
  <div class="comments">
    <h2>全部评论</h2>
    <van-list
    v-model="loading"
    :finished="finished"
    finished-text="已加载全部"
    @load="onLoad"
    >
    <div slot="loading" class="list-loading">
      <img :src="img.loading" />
    </div>
    <div class="comment">
      <van-row class="btn-bor" gutter="20" v-for="(comment, index) in comments" :key="'commment_' + comment.id">
       <!-- @click="goMy(comment.user.id)" -->
       <van-col span="3">
        <img class="avatar" :src="comment.user && comment.user.headimg_url&&comment.user.headimg_url.substring(0,5)=='https' ? comment.user.headimg_url : img.avatar" />
      </van-col>
      <van-col span="21">
        <h3>
          {{ comment.user.user_name }}
          <span class="binbox">
            <img class="binpic" @click="setCommentPraise(index)" :src="comment.is_praise ? img.collect_have : img.collect">
            <span class="sourtime">{{ comment.praise_num }}</span>
          </span>
        </h3>
        <p v-if="comment.content">{{ comment.content }}</p>
        <p class="time">{{ comment.create_time }}
          <span class="c-black" @click="replys(comment.id)"> · 回复
            <span v-if="comment.replys">({{ comment.replys.length }})</span>
          </span>
          <span v-if="comment.user.id==params.user_id" class="f-r" @click="delComment(comment.id,index)">删除</span>
          <span v-else class="f-r" @click="toTip">举报</span>
        </p>
        <div class="replys" v-if="comment.replys">
          <router-link class="f-12 c-blue" :to="{name: 'LexusAskShowComment', params: {id: comment.id,answerid:answer_id}}">
            <van-row v-for="(reply,index) in comment.replys" :key="'replys_' + reply.id" v-show="index>2?false:true">
              <van-col span="3">
                <img class="headimg" :src="reply.user.headimg_url&&reply.user.headimg_url.substring(0,5)=='https' ? reply.user.headimg_url : img.avatar" >
              </van-col>
              <van-col span="21">
                <span class="f-w" v-if="reply.user">{{ reply.user.user_name }}</span>
                <span class="pd-5" v-if="reply.reuser">回复</span>
                <span class="f-w">{{ reply.reuser.user_name }} :</span>
                {{ reply.content }}
              </van-col>
            </van-row>
          </router-link>
        </div>
      </van-col>
    </van-row>
  </div>
</van-list>
</div>
<div @touchstart="touchstart()" class="postoverlay" v-show="overlay"></div>
<div class="postbottom" id="inputid">
  <van-row>
    <van-col :span="inputnum">
      <van-field v-model="value" @click="inputFocus()" :focus="inputfocus" placeholder="发表评论..." ref="inputTag" />
    </van-col>
    <van-col  v-if="inputshow" class="botright" span="10">
      <van-row>
        <van-col span="8"> 
          <span class="binbox">
            <img class="binpic" :src="img.comment">
            <span class="num" v-if="info.answer&&info.answer.reply_num>0">{{info.answer.reply_num}}</span>
          </span>
        </van-col>
        <van-col span="10" v-if="info">
          <span class="binbox" @click="Collect(info.answer.is_praise)">
            <img class="binpic" :src="info.answer.is_praise==1?img.collect_have:img.collect">
            <span class="num" v-if="info.answer.praise_num>0">{{info.answer.praise_num}}</span>
          </span>
        </van-col>
        <van-col span="6">
          <span class="binbox" @click="outrelay(info.question,info.content,'/lexus/ask/'+info.answer.id+'/answer',info.image)">
            <img class="binpic" :src="img.outrelay">
          </span>
        </van-col>
      </van-row>
    </van-col>
    <van-col v-else span="5">
      <van-button color="#605C6B" size="small" @click="post()">发表</van-button>
    </van-col>
  </van-row>
</div>
<van-image-preview
v-model="showState"
:images="images"
:startPosition="imgIndex"
lazyLoad
>
</van-image-preview>
<van-action-sheet v-model="shareshow" :round="false" cancel-text="取消" @cancel="onCancel">
  <van-divider class="divider">分享</van-divider>
  <van-grid :border='false' :column-num="5">
    <!-- <van-grid-item :icon="img.inrelay" /> -->
    <van-grid-item :icon="img.friends" @click="toShare(2)" />
    <van-grid-item :icon="img.wechat" @click="toShare(1)" />
    <!-- <van-grid-item :icon="img.link" />
      <van-grid-item :icon="img.poster" /> -->
    </van-grid>
  </van-action-sheet>
  <van-image-preview
  v-model="showStated"
  :images="imagesd"
  lazyLoad
  >
</van-image-preview>
</div>
</template>
<script>
  import ask from '../../../api/ask';
  import content from '../../../api/content';
  import common from '../../../api/common';
  import { mapState } from 'vuex';
  import {List, Row, Col, Tag, Button,Field,Overlay,ActionSheet,Divider,Grid,GridItem} from "vant";

  export default {
    data () {
      return {
        value:'',
        inputshow:true,
        overlay:false,
        inputfocus:false,
        inputnum:14,
        params: {
          page: 1,
          size: 4,
          order: 1,
          user_id: 0
        },
        answer_id: 0,
        loading: false,
        finished: false,
        info: '',
        comments: [],
        images:[],
        imgIndex:0,
        showState:false,
        imagesd:[],
        showStated:false,
        shareshow:false,
        img: {
          avatar: require('../../../assets/img/lexus/default.png'),
          parise: require('../../../assets/img/parise.png'),
          parise_have: require('../../../assets/img/lexus/parise_have.png'),
          no_parise: require('../../../assets/img/no_parise.png'),
          show_parise: require('../../../assets/img/show_parise.png'),
          show_no_parise: require('../../../assets/img/show_no_parise.png'),
          no_parise_have: require('../../../assets/img/lexus/no_parise_have.png'),
          loading: require('../../../assets/img/loading_lexus.gif'),
          question: require('../../../assets/img/question.png'),
          answer: require('../../../assets/img/answers.png'),
          answer_black: require('../../../assets/img/answer-button-black.png'),
          collect: require('../../../assets/img/lexus/collect.png'),
          collect_have: require('../../../assets/img/lexus/collect_have.png'),
          comment: require('../../../assets/img/lexus/comment.png'),
          inrelay: require('../../../assets/img/lexus/inrelay.png'),
          outrelay: require('../../../assets/img/lexus/outrelay.png'),
          answericon: require('../../../assets/img/lexus/answericon.png'),
          questionicon: require('../../../assets/img/lexus/questionicon.png'),
          friends: require('../../../assets/img/lexus/friends.png'),
          wechat: require('../../../assets/img/lexus/wechat.png'),
          link: require('../../../assets/img/lexus/link.png'),
          poster: require('../../../assets/img/lexus/poster.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    watch: {
      '$route'() {
        if(this.$route.params.id != this.answer_id) {
          this.answer_id = this.$route.params.id
          this.getInfo()
        }
      }
    },  
    created () {
     this.$store.commit('param/show', false)
     this.$appService.isShowReturn({state: true})
     this.$appService.isTabbar({state: true})
     let id = this.$route.params.id
     this.weburl=process.env.VUE_APP_URL
     if(this.$util.isEmpty(id)) {
      this.$toast('答案不存在')
      return false
    }
    this.answer_id = id
    this.getInfo()
  },
  activated () {
    this.$store.commit('param/show', false)
    this.$appService.isShowReturn({state: true})
    this.$appService.isTabbar({state: true})
    console.log('showanswer-activated--')
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
      }
    })
  },
  methods: {
    setAdopt () {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(this.user) {
        let type = this.info.answer.is_adopt ? 2 : 1;
        ask.setAdopt({id: this.info.answer.id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.info.answer.is_adopt = 1

              //取消一般般
              if(this.info.answer.is_praiseno) {
                ask.setNoPraise({id: this.info.answer.id, type: 2}).then(res => {
                  this.info.answer.is_praiseno = 0
                })
              }
            } else {
              this.info.answer.is_adopt = 0
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }

    },
    setNoPraise () {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(this.user) {
        let type = this.info.answer.is_praiseno ? 2 : 1;
        ask.setNoPraise({id: this.info.answer.id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.info.answer.is_praiseno = 1

              //取消采纳
              if(this.info.answer.is_adopt) {
                ask.setAdopt({id: this.info.answer.id, type: 2}).then(res => {
                  this.info.answer.is_adopt = 0
                })
              }
            } else {
              this.info.answer.is_praiseno = 0
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }
    },
    setCommentPraise (index) {
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      if(this.user) {
        let type = this.comments[index].is_praise ? 2 : 1;
        ask.setCommentPraise({id: this.comments[index].id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 1) {
              this.comments[index].is_praise = 1
              this.comments[index].praise_num += 1
            } else {
              this.comments[index].is_praise = 0
              this.comments[index].praise_num -= 1
            }
          }
        })
      } else {
        this.$toast('请先登录')
        return false
      }
    },
    toTip() {
      this.$toast.success('举报成功')
    },
    getInfo () {
      let user_id = this.user ? this.user.id : 0
      ask.getAnswerShow(this.answer_id, {user_id: user_id}).then(res => {
        if(res.data.state == 1) {
          this.info = res.data.data
          this.images = []
          for(let i of res.data.data.image) {
            this.images.push(i)
          }
          if(res.data.data.question){
            document.title = res.data.data.question;
            document.querySelector('meta[name="keywords"]').setAttribute('content', res.data.data.question)
            document.querySelector('meta[name="description"]').setAttribute('content', res.data.data.question)
          }
          var params={
            event_code: '凌志范儿回答',
            event_id: this.info.id,
            title: this.info.question,
            value: '',
            path: '/Lexus/Ask/ShowAnswer.vue',
            user_id: this.user.id,
            source: this.source
          }
          common.BurialPoint(params).then(res => {
            if(res.data.state==1){

            }
          })
        }
      })
    },
      inputFocus(){//点击输入框聚焦
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        this.inputshow=false;
        this.overlay=true;
        this.inputnum=19;
        setTimeout(() => {
          var cc=document.getElementById('inputid');
          cc.scrollIntoViewIfNeeded(true);
        },500);
      },
      replys(rid){//点击回复聚焦
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        this.inputshow=false;
        this.overlay=true;
        this.inputnum=19;
        this.inputfocus=true
        this.$refs.inputTag.focus()
        this.rid=rid
        setTimeout(() => {
          var cc=document.getElementById('inputid');
          cc.scrollIntoViewIfNeeded(true);
        },500);
      },
      touchstart(){//检测触发遮罩层，失去焦点
        this.inputshow=true;
        this.overlay=false;
        this.$refs.inputTag.blur()
        this.inputnum=14;
        this.inputfocus=false
      },
      inputBlur(){//点击失去焦点
        setTimeout(() => {
          this.inputshow=true;
          this.inputnum=14;
        }, 1000);
        this.overlay=false;
        this.inputfocus=false
        this.$refs.inputTag.blur()
      },
      post(){
        let params={
          rid:this.rid,
          answer_id:this.answer_id,
          content:this.value
        }
        ask.Comment(params).then(res => {
         if(res.data.state == 1) {
          this.inputshow=true;
          this.inputnum=14;
          this.overlay=false;
          this.inputfocus=false
          this.$refs.inputTag.blur()
          this.$toast.success('发表成功')
          this.value=''
          this.finished = false
          this.comments=[]
          this.params.page = 1
        }
      })
      },
      getCommentList(){
        ask.getCommentList(this.answer_id, this.params).then(res => {
          this.comments.push.apply(this.comments, res.data.data.data)
          this.params.page += 1
          this.loading = false
          if(res.data.data.data.length == 0) {
            this.finished = true
          }
        })
      },
      Collect(type){
        this.$appService.getToken(v => {
          if(v.token) {
            this.$store.dispatch('param/setToken', v.token)
          } else {
            var params={
              url:'',
              pagetype:0
            }
            this.$appService.needLogin(params)
          }
        })
        if(type==1){
          var type=2
        }else{
          var type=1
        }
        ask.setAdopt({id: this.info.answer.id, type: type}).then(res => {
          if(res.data.state == 1) {
            if(type == 2) {
              this.info.answer.is_praise = 0
              this.info.answer.praise_num=this.info.answer.praise_num-1
            } else {
              this.info.answer.is_praise = 1
              this.info.answer.praise_num=this.info.answer.praise_num+1
            }
          }
        })
      },
      delComment(id,index){
       this.$dialog.confirm({
        message: '确定要删除吗？'
      }).then(() => {
        ask.delComment(id).then(res => {
          if(res.data.state == 1) {
            this.$toast.success('已删除')
            this.comments.splice(index,1);
          }
        })
      }).catch(() => {});
    },
    follow(e){
      this.$appService.getToken(v => {
        if(v.token) {
          this.$store.dispatch('param/setToken', v.token)
        } else {
          var params={
            url:'',
            pagetype:0
          }
          this.$appService.needLogin(params)
        }
      })
      let type = this.info.answer.user.is_follow ? 2 : 1;
      content.Follow({id: this.info.answer.user.id, type: type}).then(res => {
        if(res.data.state == 1) {
          if(type == 1) {
            this.info.answer.user.is_follow=1
            this.$toast.success('关注成功')
          } else {
            this.info.answer.user.is_follow=0
            this.$toast.success('取消关注')
          }
        }
      })
    },
    showImg(key){
      this.imgIndex = key
      this.showState = true
    },
    showImgd(image){
     var images=[]
     images.push(image)
     this.imagesd=images
     this.showStated=true
   },
   goPost(type){
    this.$appService.getToken(v => {
      if(v.token) {
        this.$store.dispatch('param/setToken', v.token)
        var params={
          id:this.info.id,
          type:type,
          title:this.info.question
        }
        this.$appService.goPost(params)
      } else {
        var params={
          pagetype:1,
          qid:this.info.id,
          type:type,
          title:this.info.question
        }
        this.$appService.needLogin(params)
      }
    })
  },
  onCancel(){
    this.actionshow=false
  },
  outrelay(title,content,url,imageUrl){
    this.shareshow=true
    this.sharetitle=title
    this.sharecontent=content
    this.shareurl=this.weburl+url
    if(imageUrl){
      this.shareimageUrl=imageUrl[0]
    }else{
      this.shareimageUrl='https://pic.motortime.com/logo/lexus_logo.png'
    }

  },
  toShare(type){
    var params={
      type:type,
      title:this.sharetitle,
      content:this.sharecontent,
      url:this.shareurl,
      imageUrl:this.shareimageUrl,
      user_id:this.user.id
    }
    this.shareshow=false
    this.$appService.shareContent(params)
  },
  goMy(id){
    var params={
      url:this.weburl+'/lexus/my/other/'+id+'?source='+this.source ,
      isReturn: true 
    }
    this.$appService.openWebView(params)
  },
  onLoad() {
    this.params.user_id = this.user ? this.user.id : 0
    setTimeout(() => {
      this.getCommentList()
    }, 500);
  }
},
components: {
  [Row.name]: Row,
  [Col.name]: Col,
  [List.name]: List,
  [Tag.name]: Tag,
  [Field.name]:Field,
  [Button.name]: Button,
  [Overlay.name]:Overlay,
  [Divider.name]:Divider,
  [Grid.name]:Grid,
  [GridItem.name]:GridItem,
  [ActionSheet.name]:ActionSheet
}
};
</script>

<style lang="scss">
.ask-show-answer {
  background-color: #F0F0F0;
  margin-bottom: 50px;
  .img {
    width: 100%;
    height: 250px;
    margin-top: 39px;
    display: block;
    object-fit: cover;
  }
  .conpdd{
    padding: 0 15px;
  }
  .q-show {
    padding: 20px 0;
    overflow: hidden;
    background-color: #FFF;
    .other{
      margin: 10px 0;
    }
    h1 {
      font-size: 15px;
      color: #3A3A3A;
    }
    p {
      margin: 0;
      font-size: 15px;
      line-height: 22px;
      color: #3A3A3A;
    }
    .van-tag {
      color: #fff;
    }
    .tip {
      text-align: right;
      .c-blue {
       font-size: 12px;
       color: #728FC4;
       background: #F2F6FA url(../../../assets/img/lexus/listask.png) no-repeat 8px center;
       background-size: 13px auto;
       width: 80px;
       height: 25px;
       line-height: 25px;
       display: inline-block;
       text-align: left;
       padding-left: 25px;
       border-radius: 1px;
       box-sizing: border-box;
     }
   }
   .titleqa{
    font-size: 15px;
    vertical-align: middle;
  }
}
.a-show {
  padding: 20px 0;
  margin-top: 10px;
  background-color: #FFF;
  .listhand{
    width:40px;
    height:40px;
    border-radius:1.5px;
  }
  .f-15{
    line-height: 22px;
    margin-top: 15px;
    span{
     vertical-align: middle;
   }
 }
 .membername{
  font-size: 13px;
  font-weight: bold;
}
.sourtime{
  font-size: 12px;
  color: #9A9A9A;
  vertical-align: middle;
}
.bintright {
  text-align:right;
  .van-button__icon{
    font-size: 12px;
  }
  .van-button__text{
    font-size: 12px;
  }
}
.parise {
  text-align: center;
  margin-top: 20px;
  margin-bottom: 20px;
  a {
   color: #3A3A3A;
   font-size: 11px;
   display: inline-block;
   width: 110px;
   height: 35px;
   line-height: 35px;
   border-radius: 2px;
   margin: 0 7px;
   box-sizing: border-box;
   background-color: #F3F9FF;
   border: none;

   img {
    width: 15px;
    height: 14px;
    vertical-align: middle;
    margin: 0;
    margin-right: 7px;
  }
  &:first-child {
    margin-left: 0;
  }
  &:last-child {
    margin-right: 0;

    img {
      width: 13px;
    }
  }
}
}
}
.comments {
  background-color: #FFF;
  margin-top: 10px;

  h2 {
    font-size: 13px;
    font-weight: normal;
    padding: 15px 10px;
    border-bottom: 1px solid #EAEAEA;
    margin: 0;
  }
  .comment {
    margin: 0 10px;
    overflow: hidden;
    .van-row {
      padding: 5px 0;
    }
    .btn-bor{
      padding: 10px 0;
      border-bottom: 1px solid #EAEAEA;
    }
    .avatar {
      width: 40px;
      height: 40px;
      object-fit: cover;
      border-radius: 1.5px;
    }
    h3 {
      font-size: 13px;
      line-height: 1.2;
      .binbox {
        color: #9A9A9A;
        font-size: 12px;
        float: right;
        font-weight: normal;

        img {
          width: 15px;
          height: 14px;
          margin-right: 11px;
          vertical-align: middle;
        }
        .sourtime{
          vertical-align: middle;
        }
      }
    }
    p {
      font-size: 13px;
      line-height: 18px;
      .c-blue {
        font-style: normal;
      }
      &.time {
        font-size: 12px;
        color: #9A9A9A;

        span {
          margin-left: 5px;
        }
      }
    }
    img {
      width: 25px;
      border-radius: 1.5px;
    }
    .replys {
      .van-row {
        font-size: 13px;
        .van-col--21{
          line-height: 1.8;
        }
      }
      .pd-5{
        padding: 0 5px;
      }
      a{
        color: #3A3A3A;
      }
      span{
        line-height: 18px;
      }
    }
  }
}
.mr-10{
  margin-right: 10px;
}
a{
  color: #3A3A3A;
}
.answtag{
  width: 15px;
  height: 15px;
  margin-right: 10px;
  vertical-align: middle;
}
.c-getother{
  color: #728FC4;
}
.follow{
  vertical-align: super;
}
.van-popup{
  .van-action-sheet__cancel::before{
    height: 1px;
  }
  .divider{
    margin: 20px 80px;
  }
}
}
</style>
